import React, { useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';
import Header from './Header.jsx';
import ChatWidget from '../ia/ChatWidget.jsx';
import { AuthContext } from '../../contexts/AuthContext.jsx';

/**
 * Mismo patrón que los proyectos hermanos (Turkimex/GGv2, ver sus `AppLayout.jsx`):
 * el sidebar vive en `position:fixed` (no en el flujo del layout), así que el
 * contenido se desplaza con un margen izquierdo (`lg:ml-64`/`lg:ml-20`) que responde
 * al colapso, en vez del `flex` anterior. Portado 2026-09-28 junto con el resto del
 * sistema de diseño (pedido explícito del usuario, con captura real de Turkimex).
 */
export default function AppLayout() {
  const { shouldShowPaymentWarning } = useContext(AuthContext);
  const [menuAbierto, setMenuAbierto] = useState(false);
  // Colapsar el menú es una preferencia de sesión larga, no algo que se pierda al
  // cambiar de pantalla -- por eso vive en localStorage, no en el estado de la ruta
  // (mismo patrón que GGv2/PartnersV2/Turkimex, ver sus `AppLayout.jsx`).
  const [menuColapsado, setMenuColapsado] = useState(() => localStorage.getItem('ibu_sidebar_colapsado') === '1');
  const alternarColapso = () => setMenuColapsado((c) => {
    localStorage.setItem('ibu_sidebar_colapsado', c ? '0' : '1');
    return !c;
  });

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar
        abierto={menuAbierto}
        onCerrar={() => setMenuAbierto(false)}
        colapsado={menuColapsado}
        onAlternarColapso={alternarColapso}
      />

      <div className={`transition-all duration-300 ${menuColapsado ? 'lg:ml-20' : 'lg:ml-64'}`}>
        <Header onAbrirMenu={() => setMenuAbierto(true)} shouldShowPaymentWarning={shouldShowPaymentWarning} />
        <main className="p-4 lg:p-6">
          <Outlet />
        </main>
      </div>

      {/* Widget flotante del Asistente IA (Fase 11, ver PLAN.md) — vive fuera de
          <Outlet /> para quedar visible en toda la app protegida, igual que en V1
          (AsistenteIAWidget montado una sola vez en src/index.js). Se auto-gatea con
          hasPermiso('asistente-ia:usar') y se auto-oculta en /asistente-ia
          (ver components/ia/ChatWidget.jsx) — no requiere ninguna condición aquí. */}
      <ChatWidget />
    </div>
  );
}
